import axios from "axios";
import { getBaseUrl } from "../helpers/utility";

export function chatLogin(payload) {
  if(payload.isJoinForm){
    return axios.post(
      `${getBaseUrl().api_url}/nursing_home_management/login_phone.json`,
      payload
    );
  }
  return axios.post(
    `${getBaseUrl().api_url}/nursing_home_management/login.json`,
    payload
  );
}

export function forgotPassword(payload) {
  return axios.post(
    `${getBaseUrl().api_url}/nursing_home_management/send_forget_password_email.json`,
    payload
  );
}

export function resetPassword(payload) {
  return axios.post(
    `${getBaseUrl().api_url}/nursing_home_management/reset_password.json`,
    payload
  );
}

export function getNursingSearch(keyword, locations) {
  return axios.get(
    `${getBaseUrl().api_url}/nursing_home_chats/patients.json?keyword=${keyword}&location_id=${locations}`,
  );
}

export function verifyPin(payload) {
  return axios.post(
    `${getBaseUrl().api_url}/nursing_home_management/verify_pin.json`,
    payload
  );
}

export function organizationConfig() {
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/organization_configurations.json`,
  );
}

export function getUserByToken(token) {
  return axios.get(
    `${getBaseUrl().api_url}/users/user_by_token.json?token=${token}`,
  );
}

export function chngePassword(payload,token) {
  return axios.post(
    `${getBaseUrl().api_url}/nursing_home_management/change_password.json?${token}&new_chat=1`,
    payload
  );
}
export function ChangePin(payload,token) {
  return axios.post(
    `${getBaseUrl().api_url}/nursing_home_management/change_pin.json?${token}&new_chat=1`,
    payload
  );
}

export function printe10xEncounterSummary(data) {

  let url = 'https://api-e10x.ethizo.com';
  
  const organization = JSON.parse(localStorage.getItem('base_url'));
  if(organization.api_url){
    url = organization.api_url.replace("api-", "api-e10x-");
  }
  
  return axios.get(
    `${url}/notes/print_summary.json?encounter_id=${data.encounter_id}&token=${data.token}`,
  );
}
